import { useQuery } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { PaginatedPackagerResponse } from '../../../types/packager-types';

const useGetPackager = (dataPoolId: string) => {
  const glynt = useGlynt();

  const queryResult = useQuery({
    queryKey: ['packager', dataPoolId],
    queryFn: async () => await (await glynt).packager.retrieve(dataPoolId),
    refetchOnWindowFocus: false,

    // 1 hour
    gcTime: 1000 * 60 * 60,

    // 10 minutes
    staleTime: 1000 * 60 * 10
  });

  return {
    ...queryResult,
    packager: queryResult.data?.results[0] || null, // default to first packager or null
    count: queryResult.data?.count ?? 0,
    hasPackagers: (queryResult.data?.count ?? 0) > 0,
  };
};

export default useGetPackager;
